// extracted by mini-css-extract-plugin
module.exports = {"sidebarOption":"SidebarOption_sidebarOption__byec_","sidebarOption_active":"SidebarOption_sidebarOption_active__2ZXWl","icon":"SidebarOption_icon__1cYgT"};